import {
    Box,
    ButtonProps,
    Card,
    Group,
    Stack,
    Text,
} from "@mantine/core";

import {
    Field,
    Form,
    Formik
} from 'formik';
import {
    FlexiButton,
    FormikCheckbox,
    PlatformFieldset
} from "@flexinet/ui-components";
import {useDeleteAccountForm} from "../hooks/useDeleteAccountForm.ts";
import {DeleteAccountFormRecordSchema} from "./DeleteAccountFormRecordSchema.ts";


const RegisterButton = (props: ButtonProps & { type: "button" | "submit" | "reset" | undefined }) =>
    <FlexiButton {...props} />

// FNP-117: after a successful submit, the hook flips `submitted` to true and
// the form swaps to a confirmation panel before signing the user out. Keeps
// the user in-page for the 5s window so the 30-day recovery message is read,
// not lost in the auth redirect.
export const DeleteAccountForm = () => {

    const {
        initialValues,
        handleSubmit,
        handleCancel,
        submitted,
    } = useDeleteAccountForm()

    if (submitted) {
        return (
            <Card shadow={'sm'} p={'xl'}>
                <Stack gap={'sm'}>
                    <Text fw={600} size={'lg'}>Account marked for deletion</Text>
                    <Text>
                        You will be signed out shortly. Contact support within
                        the next <strong>30 days</strong> to recover your account.
                        After that, all account data is permanently deleted.
                    </Text>
                </Stack>
            </Card>
        );
    }

    return (
        <Box>
            <Formik
                initialValues={initialValues}
                validationSchema={DeleteAccountFormRecordSchema}
                onSubmit={handleSubmit}
            >
                {({
                      isSubmitting,
                  }) => (

                    <Form>
                        <PlatformFieldset legend={'Confirm Delete Account'}>


                            <Field name="confirmation"
                                   label={"I understand my account will be marked for deletion. I have 30 days to recover it by contacting support, after which all data will be permanently deleted."}
                                   component={FormikCheckbox}
                                   my={'lg'}
                            ></Field>
                        </PlatformFieldset>


                        <Group justify={'flex-end'} my={'sm'}>
                            <FlexiButton variant={'subtle'} onClick={handleCancel}>Cancel</FlexiButton>
                            <RegisterButton variant={'filled'} disabled={isSubmitting}
                                            type={'submit'}>Delete Account</RegisterButton>
                        </Group>

                    </Form>

                )}
            </Formik>
        </Box>
    )
};
